var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[(_vm.isGift)?_c('v-uni-view',{class:["preview-yyEva", _vm.isGift ? "": "not"],on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.close).apply(void 0, arguments)
}}}):_c('v-uni-video',{staticClass:"preview-video",attrs:{"poster":_vm.poster,"show-fullscreen-btn":false,"src":_vm.src,"controls":"controls","autoplay":_vm.autoplay,"loop":"loop","muted":true,"object-fit":"cover","playsinline":true},on:{"play":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.openMuted).apply(void 0, arguments)
}}})],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }